import { ErrorText } from "./Styles";

interface ErrorMessageProps {
  errorMessage?: string;
}

export function ErrorMessage({ errorMessage }: ErrorMessageProps) {
  return (
    <ErrorText $visible={!!errorMessage}>
      {errorMessage}
    </ErrorText>
  );
}
